"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTaskInventoryLoadWithoutQuantity = exports.calcTaskInventoryOriginalLoad = exports.calcTaskInventoryLoad = exports.calculateAggregations = exports.calculateMaxLoad = void 0;
var get_1 = __importDefault(require("lodash/get"));
var isNil_1 = __importDefault(require("lodash/isNil"));
var hierarchy_actions_1 = require("../task_inventories/hierarchy_actions");
var value_retrieval_1 = require("../task_inventories/value_retrieval");
var with_custom_status_1 = require("../task_inventories/with_custom_status");
var with_quantity_1 = require("../task_inventories/with_quantity");
var utils_1 = require("../utils");
var aggregation_types_1 = require("./aggregation_types");
var aggregationTypeToMethod = (_a = {},
    _a[aggregation_types_1.AggregationTypes.EXPECTED_PICKUP] = aggregateExpectedPickup,
    _a[aggregation_types_1.AggregationTypes.CURRENT_LOAD] = aggregateCurrentLoad,
    _a[aggregation_types_1.AggregationTypes.MAX_LOAD] = aggregateMaxLoad,
    _a);
function getAggregationDelta(params) {
    var taskInventory = params.taskInventory, field = params.field, ignoreQuantity = params.ignoreQuantity;
    var currentValue = (0, value_retrieval_1.getTaskInventoryNumericValue)(taskInventory, field);
    var actualQuantity = (0, with_quantity_1.getActualQuantity)(taskInventory);
    return actualQuantity !== 0
        ? (taskInventory.pending ? 1 : -1) * (ignoreQuantity ? currentValue : actualQuantity * currentValue)
        : 0;
}
function isRequiredInitialLoad(aggregationType) {
    return aggregationType !== aggregation_types_1.AggregationTypes.EXPECTED_PICKUP;
}
function taskInventoryInitialLoad(pickedUpQuantities, taskInventory, inventoryHash, field, ignoreQuantity) {
    var value = 0;
    var currentValue = (0, value_retrieval_1.getTaskInventoryNumericValue)(taskInventory, field);
    var originalQuantity = (0, with_quantity_1.getOriginalQuantity)(taskInventory);
    // Drop-off task not related to a pickup
    if ((0, isNil_1.default)(pickedUpQuantities[inventoryHash])) {
        return ignoreQuantity ? currentValue : originalQuantity * currentValue;
    }
    // Drop-off task connected to a pickup task (same inventory id)
    pickedUpQuantities[inventoryHash] -= originalQuantity;
    if (pickedUpQuantities[inventoryHash] < 0) {
        var positiveQuantity = -1 * pickedUpQuantities[inventoryHash];
        value = ignoreQuantity ? currentValue : positiveQuantity * currentValue;
        pickedUpQuantities[inventoryHash] = 0;
    }
    return value;
}
function initialLoad(_a) {
    var items = _a.items, field = _a.field, ignoreQuantity = _a.ignoreQuantity, uniqueInventoryFields = _a.uniqueInventoryFields;
    var visitPickup = false;
    var pickedUpQuantities = {};
    if (items.some(function (taskInventory) { return taskInventory.inventory_id; })) {
        // For backward compatibility
        uniqueInventoryFields = ['inventory_id'];
    }
    else {
        uniqueInventoryFields = uniqueInventoryFields || [];
    }
    return items.reduce(function (value, taskInventory) {
        var hash = (0, utils_1.generateHash)(taskInventory, uniqueInventoryFields, false);
        visitPickup = visitPickup || taskInventory.pending;
        if (!(0, isNil_1.default)(hash)) {
            if (taskInventory.pending) {
                // Pickup task
                var oldQuantity = pickedUpQuantities[hash] || 0;
                pickedUpQuantities[hash] = oldQuantity + (0, with_quantity_1.getOriginalQuantity)(taskInventory);
            }
            else {
                // Drop-off task
                value += taskInventoryInitialLoad(pickedUpQuantities, taskInventory, hash, field, ignoreQuantity);
            }
        }
        else {
            if (!visitPickup) {
                var currentValue = (0, value_retrieval_1.getTaskInventoryNumericValue)(taskInventory, field);
                var originalQuantity = (0, with_quantity_1.getOriginalQuantity)(taskInventory);
                value += ignoreQuantity ? currentValue : originalQuantity * currentValue;
            }
        }
        return value;
    }, 0);
}
function aggregateMaxLoad(params) {
    var accumulatedValue = params.accumulatedValue;
    params.interimLoadValue += getAggregationDelta(params);
    return Math.max(accumulatedValue, params.interimLoadValue);
}
function aggregateCurrentLoad(params) {
    var accumulatedValue = params.accumulatedValue, taskInventory = params.taskInventory;
    var delta = 0;
    if (taskInventory.status === with_custom_status_1.TaskInventoryStatus.DONE) {
        delta = getAggregationDelta(params);
    }
    return accumulatedValue + delta;
}
function aggregateExpectedPickup(params) {
    var accumulatedValue = params.accumulatedValue, taskInventory = params.taskInventory;
    var delta = 0;
    if (taskInventory.pending && !(0, with_custom_status_1.isClosedTaskInventory)(taskInventory)) {
        delta = getAggregationDelta(params);
    }
    return accumulatedValue + delta;
}
function calculateMaxLoad(_a) {
    var items = _a.items, field = _a.field, ignoreQuantity = _a.ignoreQuantity, uniqueInventoryFields = _a.uniqueInventoryFields;
    var aggregationType = aggregation_types_1.AggregationTypes.MAX_LOAD;
    return calculateAggregations([aggregationType], { items: items, field: field, ignoreQuantity: ignoreQuantity, uniqueInventoryFields: uniqueInventoryFields })[aggregationType];
}
exports.calculateMaxLoad = calculateMaxLoad;
function calculateAggregations(aggregationTypes, _a) {
    var items = _a.items, field = _a.field, ignoreQuantity = _a.ignoreQuantity, uniqueInventoryFields = _a.uniqueInventoryFields;
    var taskInventories = items.flatMap(function (taskInventory) {
        return (0, hierarchy_actions_1.flatTaskInventoryHierarchy)(taskInventory);
    });
    var initialLoadValue;
    var initialLoadPerAggregationType = {};
    aggregationTypes.forEach(function (aggrType) {
        if (isRequiredInitialLoad(aggrType)) {
            if ((0, isNil_1.default)(initialLoadValue)) {
                initialLoadValue = initialLoad({
                    items: taskInventories,
                    field: field,
                    ignoreQuantity: ignoreQuantity,
                    uniqueInventoryFields: uniqueInventoryFields
                });
            }
            initialLoadPerAggregationType[aggrType] = initialLoadValue;
        }
        else {
            initialLoadPerAggregationType[aggrType] = 0;
        }
    });
    var interimLoadPerAggregationType = __assign({}, initialLoadPerAggregationType);
    return taskInventories.reduce(function (value, taskInventory) {
        aggregationTypes.forEach(function (aggrType) {
            var params = {
                accumulatedValue: value[aggrType],
                taskInventory: taskInventory,
                field: field,
                ignoreQuantity: ignoreQuantity,
                interimLoadValue: interimLoadPerAggregationType[aggrType]
            };
            value[aggrType] = aggregationTypeToMethod[aggrType](params);
            interimLoadPerAggregationType[aggrType] = params.interimLoadValue;
        });
        return value;
    }, initialLoadPerAggregationType);
}
exports.calculateAggregations = calculateAggregations;
function calcTaskInventoryLoadByMethod(taskInventory, field, quantityPredicate) {
    var value = (0, get_1.default)(taskInventory, field, 0);
    value = (taskInventory.inventories || []).reduce(function (acc, childInventory) { return acc + calcTaskInventoryLoadByMethod(childInventory, field, quantityPredicate); }, value);
    return quantityPredicate(taskInventory) * value;
}
function calcTaskInventoryLoad(taskInventory, field) {
    return calcTaskInventoryLoadByMethod(taskInventory, field, with_quantity_1.getActualQuantity);
}
exports.calcTaskInventoryLoad = calcTaskInventoryLoad;
function calcTaskInventoryOriginalLoad(taskInventory, field) {
    return calcTaskInventoryLoadByMethod(taskInventory, field, function (taskInventory) { return taskInventory.original_quantity; });
}
exports.calcTaskInventoryOriginalLoad = calcTaskInventoryOriginalLoad;
function calcTaskInventoryLoadWithoutQuantity(taskInventory, field) {
    return calcTaskInventoryLoadByMethod(taskInventory, field, function () { return 1; });
}
exports.calcTaskInventoryLoadWithoutQuantity = calcTaskInventoryLoadWithoutQuantity;
//# sourceMappingURL=task_inventories_load_aggregator.js.map